import { create as createMonacoGraphQLAPI } from './api';
import { languages } from './monaco-editor';
export const LANGUAGE_ID = 'graphql';
let api;
export function initializeMode(config) {
    if (!api) {
        api = createMonacoGraphQLAPI(LANGUAGE_ID, config);
        languages.graphql = { api };
        void getMode().then(mode => mode.setupMode(api));
    }
    return api;
}
function getMode() {
    return import('./graphqlMode.js');
}
//# sourceMappingURL=initialize.js.map